import logger from '../../../services/logger';
import type {ReliefReason} from './videoReliefAdvisor';

export type ReliefSurface = 'matrix' | 'group';

export interface ReliefLog {
    readonly promptShown: (reason: ReliefReason | 'recovered') => void;
    readonly paused: (mode: 'renegotiate' | 'local') => void;
    readonly accepted: (action: 'pause' | 'resume') => void;
    readonly dismissed: (action: 'pause' | 'resume') => void;
    readonly resumed: (how: 'prompt' | 'tile' | 'manual') => void;
    readonly failed: (action: 'pause' | 'resume', error: unknown, reason?: 'camera') => void;
}

const message = (error: unknown): string => (error instanceof Error ? error.message : String(error));

export const createReliefLog = (surface: ReliefSurface): ReliefLog => ({
    promptShown: reason => logger.info('Video relief prompt shown', {source: 'call_video', event: 'relief_prompt_shown', surface, reason}),
    paused: mode => logger.info('Video relief paused', {source: 'call_video', event: 'relief_paused', surface, mode}),
    accepted: action => logger.info('Video relief accepted', {source: 'call_video', event: 'relief_accepted', surface, action}),
    dismissed: action => logger.info('Video relief dismissed', {source: 'call_video', event: 'relief_dismissed', surface, action}),
    resumed: how => logger.info('Video relief resumed', {source: 'call_video', event: 'relief_resumed', surface, how}),
    failed: (action, error, reason) =>
        logger.warn('Video relief failed', {source: 'call_video', event: 'relief_failed', surface, action, reason, error: message(error)}),
});
